var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpeV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.999,
    height: 71.999,
    viewBox: "0 0 71.999 71.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    width: 71.999,
    height: 71.999,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    d: "M36,72A36,36,0,1,1,72,36,36.04,36.04,0,0,1,36,72M36,4.564A31.436,31.436,0,1,0,67.436,36,31.472,31.472,0,0,0,36,4.564",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    d: "M69.785,103.036h6.56l-.133-2.888H69.242Z",
    transform: "translate(-29.742 -43.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    d: "M63.605,44.982h8.8l-.164-3.533H63.605Z",
    transform: "translate(-27.321 -17.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    d: "M63.605,62.671l3.108,16.5h7.052l-1.228-26.53H63.605Z",
    transform: "translate(-27.321 -22.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    d: "M88.715,65.846l-.323-2.273H83.716l.435,2.273Z",
    transform: "translate(-35.959 -27.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    d: "M55.98,41.449H47.344l-.163,3.533h8.8Z",
    transform: "translate(-20.266 -17.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    d: "M46.024,52.642,44.8,79.172h7.052l3.107-16.5V52.642Z",
    transform: "translate(-19.242 -22.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    d: "M44.516,103.036h6.56l.544-2.888H44.65Z",
    transform: "translate(-19.121 -43.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    width: 2.5,
    height: 1.372,
    transform: "translate(20.044 32.907) rotate(-81.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    d: "M33.733,65.846H38.3l.435-2.273H34.056Z",
    transform: "translate(-14.49 -27.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    d: "M63.84,18.919H57.9l2.972,1.055Z",
    transform: "translate(-24.868 -8.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    d: "M77.492,30.279c-.944-6.067-6.831-7.208-6.831-7.208H67.85L63.6,24.719V30.7H72.11l0-.039.007.039h0l0,.034,2.847,14.869h4.7Zm-8.839-.507H65.676V28.061h2.977Z",
    transform: "translate(-27.321 -9.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    d: "M46.263,23.071h-2.81s-5.888,1.141-6.831,7.208l-1.351,9.5,1.922.274-.513,3.6-1.922-.273-.316,2.224h4.7l2.848-14.877,0-.026h0l.007-.039,0,.039h8.5V24.719Z",
    transform: "translate(-14.794 -9.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    d: "M67.273,19.37l-3.668,1.3v1.845l2.669-1.036,1.416-.55Z",
    transform: "translate(-27.321 -8.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    d: "M55.862,19.37l-.418,1.561,1.416.55,2.669,1.036V20.673Z",
    transform: "translate(-23.816 -8.32)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpeV2);
export default __webpack_public_path__ + "static/media/ppe-v2.104ef5c7506ac90b2e5a9734c3e931cc.svg";
export { ForwardRef as ReactComponent };